import PropTypes from 'prop-types'
import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import { fullDayDateAndTimeWithTimezone } from '@utils/dateUtils'

const useStyles = makeStyles({
  toggle: {
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:focus:not(:focus-visible)': {
      outline: 'none',
    },
  },
})

function SessionsAccordion({
  sessions = [],
  timezone,
  isExpanded = false,
  setIsExpanded = () => {},
  sessionCount,
  loading = false,
  variant = 'body1',
  classes = {},
}) {
  const styles = useStyles()
  const toggle = () => setIsExpanded(!isExpanded)
  const listSpacing = classes.list ? {} : { pt: 1, pl: 2 }
  const sessionSpacing = classes.session ? {} : { pb: 1 }

  return (
    <>
      <Typography
        variant={variant}
        color="primary"
        role="button"
        tabIndex={0}
        aria-expanded={Boolean(isExpanded)}
        className={[styles.toggle, classes.toggle].filter(Boolean).join(' ')}
        onClick={toggle}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            toggle()
          }
        }}
      >
        {sessionCount ?? sessions.length} sessions
      </Typography>
      <Box
        {...listSpacing}
        className={classes.list}
        style={isExpanded ? undefined : { display: 'none' }}
      >
        {loading ? (
          <Typography variant={variant} className={classes.session}>Loading sessions…</Typography>
        ) : sessions.map((s) => (
          <Box {...sessionSpacing} key={s.startDateTime}>
            <Typography variant={variant} className={classes.session}>
              <span suppressHydrationWarning>
                {fullDayDateAndTimeWithTimezone(s.startDateTime, s.endDateTime, timezone || 'UTC')}
              </span>
            </Typography>
          </Box>
        ))}
      </Box>
    </>
  )
}

SessionsAccordion.propTypes = {
  sessions: PropTypes.arrayOf(PropTypes.shape({
    startDateTime: PropTypes.string,
    endDateTime: PropTypes.string,
  })),
  timezone: PropTypes.string,
  isExpanded: PropTypes.bool,
  setIsExpanded: PropTypes.func,
  /** Label count when `sessions` has not loaded yet; defaults to `sessions.length`. */
  sessionCount: PropTypes.number,
  loading: PropTypes.bool,
  /** Typography variant for the toggle and session lines. */
  variant: PropTypes.string,
  /**
   * Optional class overrides. Passing `list` or `session` replaces the
   * default list indent / per-session bottom padding.
   */
  classes: PropTypes.shape({
    toggle: PropTypes.string,
    list: PropTypes.string,
    session: PropTypes.string,
  }),
}
export default SessionsAccordion
